import * as d3 from 'd3'

export default {

  methods: {

    draw_Elements() {

      let title = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, 0)`)

      if(this.title.visible == 'Y') {
        title
        .append('text')
        .attr('x', 0).attr('y', this.title.y + this.title.tSize*0.4)
        .attr('fill', this.title.tColor).attr('font-size', this.title.tSize).attr('font-weight', this.title.weight)
        .text(this.title.name)
      }

      this.coreValue() // -----> Below
      this.itemValue() // -----> Below
    },


    coreValue() {

      let col = this.columns[0]
      
      let keyValue = this.canvasForms
      .append('g')
      .attr('transform', `translate(${col.x}, ${col.y})`)
      
      keyValue
      .append('text')
      .attr('id', `CORE_${this.localId}`)
      .attr('fill', col.vColor).attr('font-size', col.vSize).attr('font-weight', col.weight)
      .text(this.rawData[col.code])
      .call(this.event_Link, col)

      keyValue
      .append('text')
      .attr('y', -(col.vSize))
      .attr('fill', col.tColor).attr('font-size', col.tSize).attr('font-weight', col.weight)
      .text(col.name)
      
      keyValue
      .append('text')
      .attr('x', this.getNode(`#CORE_${this.localId}`, 'width') + 3)
      .attr('fill', col.uColor).attr('font-size', col.tSize).attr('font-weight', col.weight)
      .text(col.unit ? col.unit : '')
    },



    itemValue() {

      this.columns.forEach((d,i)=> {
        if(i==0) return

        let prog = this.rawData[d.code]/this.rawData.TOTAL
        let proLen = this.bar.size * prog

        let vlaue = this.canvasForms
        .append('g')
        .attr('transform', `translate(${d.x + this.values.margin}, ${d.y})`)
        
        vlaue // Bar Background
        .append('rect')
        .attr('y', -this.bar.height/2)
        .attr('rx', this.bar.radius)
        .attr('width', this.bar.size).attr('height', this.bar.height)
        .attr('fill', this.bar.color).attr('opacity', this.bar.opacity)

        vlaue // Actual
        .append('rect')
        .attr('y', -this.bar.height/2)
        .attr('rx', this.bar.radius)
        .attr('width', proLen).attr('height', this.bar.height)
        .attr('fill', d.bColor).attr('opacity', d.opacity)

        vlaue
        .append('text')
        .attr('x', 2).attr('y', this.values.vSize*0.36)
        .attr('fill', d.vColor).attr('font-size', this.values.vSize)
        .text(this.rawData[d.code])
        .call(this.event_Link, d)

        vlaue
        .append('text')
        .attr('y', -this.bar.height/2 - 3)
        .attr('fill', d.tColor).attr('font-size', this.values.tSize)
        .text(d.name)

      })
      

    },
  } 
}